import React from 'react';

import { HeadTitle, Spacer, Divider, TextButton, Popup } from 'oui';
import { SideBox } from '../etc/LBox/LBox';
import useNotiPreInforms from '../../application/bloc/useNotiPreInforms';
import InfoTable from '../dataDisplay/InfoTable/InfoTable';

const NotiPreInforms = () => {
  const {
    openPopup,
    setPopup,
    cancelNoti,
    openPopupConfirm,
    informs,
    sendBeaconClkBtnCnclSucc,
  } = useNotiPreInforms();

  const handleClickCancelPopup = () => {
    void cancelNoti();
    sendBeaconClkBtnCnclSucc('정기 알림 해지 완료');
  };

  return (
    <>
      <HeadTitle textTitle={'나의 입력 정보'} />

      <InfoTable informs={informs} direction={'row'} />
      <Spacer size={'md'} />

      <Divider type={'contents'} />
      <HeadTitle
        textTitle={'서비스 해지'}
        subTitle={'서비스 해지를 하면 더 좋은 대출 조건 알림을 받을 수 없어요.'}
      />
      <SideBox style={{ textAlign: 'right' }}>
        <TextButton
          size={'sm'}
          text={'해지하기'}
          state={'enabled'}
          iconRight={{ name: 'ArrowForwardIosSharp', size: 'sm' }}
          onClickButton={() => setPopup(true)}
        />
      </SideBox>

      <Popup
        title={'그래도 서비스 해지를 진행하겠어요?'}
        isPopupOpen={openPopup}
        confirmBtn={{ text: '예', onClick: () => setPopup(false) }}
        cancelBtn={{ text: '아니오', onClick: handleClickCancelPopup }}
      />

      <Popup
        title={
          '더 좋은 대출 조건을 알림 받고싶으면\n 언제든지 다시 신청해주세요.'
        }
        isPopupOpen={openPopupConfirm}
        confirmBtn={{ text: '확인', onClick: () => {} }}
      />
    </>
  );
};

export default NotiPreInforms;
